import { render, staticRenderFns } from "./EmbedVeridas.vue?vue&type=template&id=47c8342b&scoped=true"
import script from "./EmbedVeridas.vue?vue&type=script&lang=js"
export * from "./EmbedVeridas.vue?vue&type=script&lang=js"
import style0 from "./EmbedVeridas.vue?vue&type=style&index=0&id=47c8342b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8342b",
  null
  
)

export default component.exports